import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'topo-tooltip',
    templateUrl: './tool-tip.component.html',
    styleUrls: ['./tool-tip.component.scss'],
    standalone: false
})
export class ToolTipComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
